module.exports = __webpack_public_path__ + "img/INDUSTRIA_03_prew.f7939599.jpg";